import CarPoolSubhead from './CarPoolSubhead'
import { lazy, Suspense } from 'react';

const CarpoolLaunch = lazy(() =>
  import("./CarpoolLaunch").then(module => ({ default: module.CarpoolLaunch }))
);
const CarpoolLabel = lazy(() =>
  import("./CarpoolLabel").then(module => ({ default: module.CarpoolLabel }))
);
const CarpoolTech = lazy(() =>
  import("./CarpoolTech").then(module => ({ default: module.CarpoolTech }))
);
const CarpoolCustom = lazy(() =>
  import("./CarpoolCustom").then(module => ({ default: module.CarpoolCustom }))
);
const CarpoolWork = lazy(() =>
  import("./CarpoolWork").then(module => ({ default: module.CarpoolWork }))
);
const CarpoolValue = lazy(() =>
  import("./CarpoolValue").then(module => ({ default: module.CarpoolValue }))
);
const CarpoolStart = lazy(() =>
  import("./CarpoolStart").then(module => ({ default: module.CarpoolStart }))
);
const CarpoolSetup = lazy(() =>
  import("./CarpoolSetup").then(module => ({ default: module.CarpoolSetup }))
);
const CarpoolFeature = lazy(() =>
  import("./CarpoolFeature").then(module => ({ default: module.CarpoolFeature }))
);
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

// Default exports
const ShuttleTeamLogo = lazy(() =>  import("../shuttle_software/ShuttleTeamLogo"));
const ShuttleItNeed = lazy(() =>  import("../shuttle_software/ShuttleItNeed"));
const ShuttleAppreciations = lazy(() =>  import("../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() =>  import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. How customizable is the white-label carpool app?",
    answer: "Our white-label carpool app is fully customizable. You can tailor the UI, features, workflows, vehicle types, ride policies, pricing models, and branding to match your operating model-whether it’s peer-to-peer carpooling, corporate carpooling software, bikepooling, or private rideshare networks.",
  },
  {
    id: "1",
    question: "02. Does the software support real-time tracking for carpooling?",
    answer: "Yes. The platform includes real-time GPS tracking, live route updates, driver ETA, and trip monitoring. Both riders and admins can track rides instantly, making the entire carpooling and rideshare experience more transparent and secure.",
  },
  {
    id: "2",
    question: "03. Can the platform handle large corporate fleets?",
    answer: "Absolutely. The system is designed to support enterprise-scale operations, including large workforce mobility programs, multi-location fleets, and thousands of daily ride requests. It’s built for high availability and peak-load performance.",
  },
  {
    id: "3",
    question: "04. How long does it take to implement the carpooling software?",
    answer: "You can launch your complete white-label carpool and rideshare platform in as little as 20 days. Custom modules or advanced workflows may require additional time depending on complexity.",
  },
  {
    id: "4",
    question: "05. Is the platform compatible with other corporate systems?",
    answer: "Yes. The system supports seamless integration with HRMS, payroll, attendance systems, access control, third-party ERPs, and other workplace mobility tools. APIs are available for smooth data exchange.",
  },
  {
    id: "5",
    question: "06. Do you offer both cloud-based and on-premises deployment options?",
    answer: "Yes, we offer both. Cloud-based deployment ensures faster launch and lower maintenance. On-premises deployment is available for enterprises needing complete control over infrastructure and data governance.",
  },
  {
    id: "6",
    question:
      "07. What business models does your carpooling and rideshare software support?",
    answer: "Our platform supports all major carpooling and rideshare business models, including peer-to-peer carpooling, corporate carpooling software, employee commute programs, private rideshare networks, bikepooling, scooter sharing, and intracity/outstation ride-sharing. You can choose your operating model and fully customize the workflow to match your market needs.",
  },
  {
    id: "7",
    question:
      "08. Why choose your platform over other carpool or rideshare software providers?",
    answer: "Our platform is built for scalability, customization, and real-world mobility operations. You get a fully white-label solution, enterprise-grade security, seamless integrations, multi-vehicle support, and fast deployment-usually within 20 days. Unlike generic platforms, we offer end-to-end flexibility to launch any type of carpooling or rideshare business with long-term technical support.",
  },
];

export default function CarPooling() {
  const carpoolFeatureId = 'carpool-and-rideshare-software';
  return (
    <>
      <CarPoolSubhead />

      <Suspense fallback={null}>
        <CarpoolLaunch />
        <CarpoolLabel />
        <ShuttleTeamLogo />
        <CarpoolTech />
        <CarpoolCustom />
        <CarpoolWork />
        <CarpoolValue />
        <CarpoolStart />
        <CarpoolSetup />
        <CarpoolFeature />
        <div className="solution-case">
          <OnDemandWork filterData={"Carpool app"}/>
        </div>
        <ShuttleAppreciations />
        <ShuttleItNeed featureId={carpoolFeatureId} />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  );
}
